import Vue from 'vue';
import { getBlockById } from '../../blocks/getBlockById';
import { deleteBlockFrom } from './deleteBlockFrom';

export function createBlockRemover(vueModel) {
	return new Vue({
		data() {
			return {
				blocks: vueModel.blocks
			};
		},
		methods: {
			canDeleteBlock(id) {
				const block = getBlockById(this.blocks, id);
				return block && block.protection ? !block.protection.delete : false;
			},
			deleteBlock(id) {
				if (this.canDeleteBlock(id)) deleteBlockFrom(this.blocks, id);
			}
		}
	});
}